import { Fragment, useEffect, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { CheckIcon } from "@heroicons/react/24/outline";
import { useNavigate, useParams } from "react-router-dom";
import { axiosInstance } from "../utils/axios";
import ComboboxSearchClient from "../components/form/ComboboxSearchClient";
import useModalStore from "../stores/useModalStore";
import { toast } from "react-toastify";

export default function ManageStockModal(props) {
  const [firstOpen, setFirstOpen] = useState(true);
  const [open, setOpen] = useState(true);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    device_id: props.id,
    status: props.status,
    client: { name: null, id: null, newId: null },
    invoice_number: null,
    invoice_date: new Date().toISOString().split("T")[0],
  });
  const [clients, setClients] = useState([]);
  const cancelButtonRef = useRef(null);
  const { setShowModal, client, setClient } = useModalStore();

  useEffect(() => {
    if (firstOpen) {
      setFirstOpen(false);

      if (client != null) {
        setFormData((prevData) => ({
          ...prevData,
          client: client,
        }));

        setClients(client);
      }
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
    setShowModal(false);
  };

  const handleClientChange = (updatedValues) => {
    setClients(updatedValues[0]);
    setClient(updatedValues[0]);
    console.log("handleClientChange", updatedValues);
  };

  const handleSelectedModelChange = (selectedItem) => {
    if (selectedItem != undefined) {
      setFormData((prevData) => ({
        ...prevData,
        client: selectedItem,
      }));

      setClient(selectedItem);
    }
  };

  const handleReserve = async () => {
    console.log("test1", formData);

    if (!formData.invoice_number) {
      setError("Invoice number is required.");
      return;
    }

    if (formData.client.id == null && formData.client.newId == null) {
      setError("Client ID is required.");
      return;
    }

    if (formData.client.newId != null) {
      formData.client.id = "A" + formData.client.newId;
      delete formData.client.newId;
    }

    console.log("formData", formData);
    try {
      const response = await axiosInstance.post(
        window.REACT_APP_API_ENDPOINT + "/device-statuses",
        formData
      );

      console.log("Device status", response.data);
      setError(null);
      toast.success("Device reserved successfully!");
      setFormData({});
      setClient(null);
      setOpen(false);
      setShowModal(false);
      props.onSuccess();
    } catch (error) {
      setError("device status error");
      console.error("device status error:", error);
      if (window.toast) {
        window.toast.error("Failed to reserve device");
      } else if (window.toastr) {
        window.toastr.error("Failed to reserve device");
      }
    }
  };

  const handleSold = async () => {
    console.log("test2", formData);

    if (!formData.invoice_number) {
      setError("Invoice number is required.");
      return;
    }

    try {
      const response = await axiosInstance.put(
        window.REACT_APP_API_ENDPOINT + "/device-statuses/" + props.device.id,
        formData
      );

      console.log("Device status update", response.data);
      setError(null);
      setOpen(false);
      setShowModal(false);
      props.onSuccess(); // Apply refetch here
    } catch (error) {
      setError("device status update error");
      console.error("device status update error:", error);
    }
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={handleClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                <div>
                  <div className="mt-3 text-center sm:mt-5">
                    <Dialog.Title
                      as="h3"
                      className="text-xl font-semibold leading-6 text-gray-900"
                    >
                      {props.status === "reserved" ? "Reserve" : "Mark as sold"}
                    </Dialog.Title>
                    <div className="mt-2">
                      <div className="px-2">
                        <div className="flex flex-col gap-2">
                          <ComboboxSearchClient
                            title="Model"
                            client={client}
                            onValuesChange={handleClientChange}
                            values={clients}
                            onSelectedItemChange={handleSelectedModelChange}
                          />
                          {formData?.client?.id == null &&
                            formData?.client?.name != null && (
                              <div className="text-left">
                                <label className="block text-sm font-semibold text-gray-800 mb-1">
                                  Client ID{" "}
                                  <span className="text-red-500">*</span>
                                </label>

                                <div className="relative">
                                  <div className="absolute inset-y-0 left-0 flex items-center px-3 border-[1px]  rounded-l-md bg-blue-50 border-blue-300 pointer-events-none">
                                    <span className="">A</span>
                                  </div>
                                  <input
                                    type="number"
                                    className="mt-1 block w-full rounded-lg border border-gray-300 px-4 py-2 pl-12 text-gray-900 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                                    value={formData.client.id}
                                    onChange={(e) => {
                                      console.log("e", e.target.value);
                                      setFormData((prev) => ({
                                        ...prev,
                                        client: {
                                          ...prev.client,
                                          newId: e.target.value,
                                        },
                                      }));
                                    }}
                                    required
                                  />
                                </div>
                                <p className="mt-1 text-sm text-gray-500">
                                  Numbers only (A will be added automatically)
                                </p>
                              </div>
                            )}
                          <div className="text-left">
                            <label className="block text-sm font-semibold text-gray-800 mb-1">
                              Invoice Number{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="text"
                              className="mt-1 block w-full rounded-lg border border-gray-300 px-4 py-2 text-gray-900 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                              placeholder="Enter invoice number"
                              value={formData.invoice_number}
                              onChange={(e) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  invoice_number: e.target.value,
                                }))
                              }
                              required
                            />
                          </div>
                          <div className="text-left">
                            <label className="block text-sm font-semibold text-gray-800 mb-1">
                              Invoice Date
                            </label>
                            <input
                              type="date"
                              className="mt-1 block w-full rounded-lg border border-gray-300 px-4 py-2 text-gray-900 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                              placeholder="Enter invoice date"
                              value={formData.invoice_date}
                              onChange={(e) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  invoice_date: e.target.value,
                                }))
                              }
                            />
                          </div>
                          {/* <div
                            className={`flex items-center px-4 border border-textBlue rounded dark:border-textBlue h-8 mr-2 mb-2 ${
                              reserveDoneFormData["recycled_date"]
                                ? "bg-blue-200"
                                : "bg-white"
                            }`}
                            onClick={() => {
                              setReserveDoneFormData((prevState) => ({
                                ...prevState,
                                is_reserve_done: !prevState.is_reserve_done,
                              }));
                            }}
                          >
                            <div
                              className={`w-4 h-4 border border-textBlue rounded-full mr-2 ${
                                reserveDoneFormData["is_reserve_done"]
                                  ? "bg-blue-600"
                                  : "bg-white"
                              }`}
                            />
                            Done
                          </div> */}
                        </div>
                      </div>
                    </div>

                    <p className="mt-2 text-sm text-red-600" id="email-error">
                      {error}
                    </p>
                  </div>
                </div>

                <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:col-start-2"
                    onClick={
                      props.status === "reserved" ? handleReserve : handleSold
                    }
                  >
                    Reserve
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                    onClick={() => {
                      setOpen(false);
                      setShowModal(false);
                    }}
                    ref={cancelButtonRef}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
